import { AdvancedMarker, Pin } from "@vis.gl/react-google-maps";
function MapMarker(props) {
  return props.markers && props.markers.length > 0 ? (
    <>
      {props.markers.map((mark) => {
        if (mark.CUSTOM_DATA && mark.CUSTOM_DATA.MachineLocation) {
          var point = mark.CUSTOM_DATA.MachineLocation;
          const myArray = point.split("loc:");
          const geo = myArray[1];
          const latIndex = geo.indexOf(".");
          const lat = parseFloat(geo.slice(0, latIndex + 6));
          const long = parseFloat(geo.slice(latIndex + 7));
          console.log(lat + " : " + long);

          return (
            <AdvancedMarker
              key={mark._id}
              title={mark.CUSTOM_DATA.ProblemDescription}
              content={mark.CUSTOM_DATA.ProblemDescription}
              position={{ lat: lat, lng: long }}
              Clickable={true}
              onClick={() => props.onClick(mark._id)}
            >
              <Pin
                background={"#FBBC04"}
                glyphColor={"#000"}
                borderColor={"#000"}
              />
            </AdvancedMarker>
          );
        }
        return null;
      })}
    </>
  ) : null;
}
export default MapMarker;
